/**
 * VendorPortalRatingService
 * Service for viewing vendor ratings (read-only).
 * Route: api/vendor-portal/ratings
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalRatingService
 * Handles vendor rating viewing for the vendor portal (read-only).
 * Maps to /api/vendor-portal/ratings endpoint
 */
export class VendorPortalRatingService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalRatingService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalRatingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all ratings for the current vendor
     * GET /api/vendor-portal/ratings
     */
    async getRatings() {
        const response = await this.getRatingsRaw();
        return response.data ?? [];
    }
    /**
     * Get all ratings (raw response)
     */
    getRatingsRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific rating by ID
     * GET /api/vendor-portal/ratings/{id}
     */
    async getRating(id) {
        const response = await this.getRatingRaw(id);
        if (!response.data) {
            throw new Error(`Rating with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific rating (raw response)
     */
    getRatingRaw(id) {
        return this.get(String(id));
    }
    // ==================== SUMMARY ====================
    /**
     * Get rating summary for the current vendor
     * GET /api/vendor-portal/ratings/summary
     */
    async getSummary() {
        const response = await this.getSummaryRaw();
        if (!response.data) {
            throw new Error('Failed to retrieve rating summary');
        }
        return response.data;
    }
    /**
     * Get rating summary (raw response)
     */
    getSummaryRaw() {
        return this.get('summary');
    }
}
VendorPortalRatingService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorPortalRatingService.BASE_PATH = 'api/vendor-portal/ratings';
//# sourceMappingURL=VendorPortalRatingService.js.map